import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import useAuthStore from './store/authStore';
import api from './utils/api';

import Landing          from './pages/Landing';
import Login            from './pages/Login';
import Cadastro         from './pages/Cadastro';
import RedefinirSenha   from './pages/RedefinirSenha';
import VagasPublicas    from './pages/VagasPublicas';
import DashCandidato    from './pages/candidato/Dashboard';
import PerfilCandidato  from './pages/candidato/Perfil';
import MatchesCandidato from './pages/candidato/Matches';
import DestaqueCandidato  from './pages/candidato/Destaque';
import DashEmpresa      from './pages/empresa/Dashboard';
import GerenciarVagas   from './pages/empresa/GerenciarVagas';
import NovaVaga         from './pages/empresa/NovaVaga';
import MatchEmpresa     from './pages/empresa/Match';
import PagamentoEmpresa from './pages/empresa/Pagamento';
import PerfilEmpresa    from './pages/empresa/Perfil';
import SelecaoEmpresa   from './pages/selecao/Selecao';
import MatchTinder      from './pages/match/MatchTinder';
import Chat             from './pages/chat/Chat';
import DashAdmin        from './pages/admin/Dashboard';
import AdminPagamentos  from './pages/admin/Pagamentos';
import AdminUsuarios    from './pages/admin/Usuarios';
import AdminEmpresas    from './pages/admin/Empresas';
import AdminCandidatos  from './pages/admin/Candidatos';
import AdminFinanceiro        from './pages/admin/Financeiro';
import AdminPerfilCandidato   from './pages/admin/PerfilCandidato';
import AdminPerfilEmpresa     from './pages/admin/PerfilEmpresa';
import AdminPreviewCandidato  from './pages/admin/PreviewCandidato';
import AdminPreviewEmpresa    from './pages/admin/PreviewEmpresa';
import AdminCobrancas         from './pages/admin/Cobrancas';
import AdminDebug             from './pages/admin/Debug';
import AdminAnalytics         from './pages/admin/Analytics';
import AdminNotificacoes      from './pages/admin/Notificacoes';
import AdminLogs              from './pages/admin/Logs';
import AdminConfiguracoes     from './pages/admin/Configuracoes';
import PoliticaPrivacidade    from './pages/PoliticaPrivacidade';
import TermosUso              from './pages/TermosUso';
import ComoFunciona           from './pages/ComoFunciona';
import Contato                from './pages/Contato';
import QuemSomos              from './pages/QuemSomos';

const Guard = ({ children, tipos = [], requirePagamento = false }) => {
  const { token, user } = useAuthStore();
  if (!token) return <Navigate to="/login" replace />;
  if (tipos.length && !tipos.includes(user?.tipo)) return <Navigate to="/" replace />;
  // Redireciona empresa com status pendente para pagamento (exceto a própria página de pagamento)
  if (user?.tipo === 'empresa' && requirePagamento &&
      user?.status_pagamento === 'pendente' &&
      !window.location.pathname.includes('/empresa/pagamento')) {
    return <Navigate to="/empresa/pagamento" replace />;
  }
  return children;
};

export default function App() {
  const { token } = useAuthStore();
  useEffect(() => {
    if (token) api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    else delete api.defaults.headers.common['Authorization'];
  }, [token]);

  return (
    <BrowserRouter>
      <Toaster position="top-right" toastOptions={{ style:{ fontFamily:'Inter', fontSize:'13px' }, success:{ iconTheme:{ primary:'#1a6b45', secondary:'#fff' } } }}/>
      <Routes>
        <Route path="/"         element={<Landing/>}/>
        <Route path="/login"    element={<Login/>}/>
        <Route path="/cadastro" element={<Cadastro/>}/>
        <Route path="/vagas"    element={<VagasPublicas/>}/>

        <Route path="/candidato"         element={<Guard tipos={['candidato']}><DashCandidato/></Guard>}/>
        <Route path="/candidato/perfil"  element={<Guard tipos={['candidato']}><PerfilCandidato/></Guard>}/>
        <Route path="/candidato/matches" element={<Guard tipos={['candidato']}><MatchesCandidato/></Guard>}/>
        <Route path="/candidato/destaque"         element={<Guard tipos={['candidato']}><DestaqueCandidato/></Guard>}/>
        <Route path="/candidato/destaque/retorno" element={<Guard tipos={['candidato']}><DestaqueCandidato/></Guard>}/>

        <Route path="/empresa"            element={<Guard tipos={['empresa']} requirePagamento><DashEmpresa/></Guard>}/>
        <Route path="/empresa/perfil"     element={<Guard tipos={['empresa']} requirePagamento><PerfilEmpresa/></Guard>}/>
        <Route path="/empresa/vagas"      element={<Guard tipos={['empresa']} requirePagamento><GerenciarVagas/></Guard>}/>
        <Route path="/empresa/vagas/nova" element={<Guard tipos={['empresa']} requirePagamento><NovaVaga/></Guard>}/>
        <Route path="/empresa/match/:id"  element={<Guard tipos={['empresa']} requirePagamento><MatchEmpresa/></Guard>}/>
        <Route path="/empresa/pagamento"         element={<Guard tipos={['empresa']}><PagamentoEmpresa/></Guard>}/>
        <Route path="/empresa/pagamento/retorno" element={<Guard tipos={['empresa']}><PagamentoEmpresa/></Guard>}/>
        <Route path="/empresa/selecao"    element={<Guard tipos={['empresa']} requirePagamento><SelecaoEmpresa/></Guard>}/>

        <Route path="/match" element={<Guard tipos={['empresa','candidato']}><MatchTinder/></Guard>}/>
        <Route path="/chat"  element={<Guard tipos={['empresa','candidato']}><Chat/></Guard>}/>

        <Route path="/admin"                          element={<Guard tipos={['admin']}><DashAdmin/></Guard>}/>
        <Route path="/admin/pagamentos"             element={<Guard tipos={['admin']}><AdminPagamentos/></Guard>}/>
        <Route path="/admin/usuarios"               element={<Guard tipos={['admin']}><AdminUsuarios/></Guard>}/>
        <Route path="/admin/candidatos/:id"         element={<Guard tipos={['admin']}><AdminPerfilCandidato/></Guard>}/>
        <Route path="/admin/empresas/:id"           element={<Guard tipos={['admin']}><AdminPerfilEmpresa/></Guard>}/>
        <Route path="/admin/empresas"   element={<Guard tipos={['admin']}><AdminEmpresas/></Guard>}/>
        <Route path="/admin/candidatos" element={<Guard tipos={['admin']}><AdminCandidatos/></Guard>}/>
        <Route path="/admin/financeiro"          element={<Guard tipos={['admin']}><AdminFinanceiro/></Guard>}/>
        <Route path="/admin/preview/candidato"   element={<Guard tipos={['admin']}><AdminPreviewCandidato/></Guard>}/>
        <Route path="/admin/preview/empresa"     element={<Guard tipos={['admin']}><AdminPreviewEmpresa/></Guard>}/>
        <Route path="/admin/cobrancas"           element={<Guard tipos={['admin']}><AdminCobrancas/></Guard>}/>
        <Route path="/admin/debug"               element={<Guard tipos={['admin']}><AdminDebug/></Guard>}/>
        <Route path="/admin/analytics"           element={<Guard tipos={['admin']}><AdminAnalytics/></Guard>}/>
        <Route path="/admin/notificacoes"        element={<Guard tipos={['admin']}><AdminNotificacoes/></Guard>}/>
        <Route path="/admin/logs"                element={<Guard tipos={['admin']}><AdminLogs/></Guard>}/>
        <Route path="/admin/configuracoes"       element={<Guard tipos={['admin']}><AdminConfiguracoes/></Guard>}/>

        <Route path="/politica-privacidade" element={<PoliticaPrivacidade/>}/>
        <Route path="/termos-uso"           element={<TermosUso/>}/>
        <Route path="/como-funciona" element={<Guard tipos={["candidato","empresa","admin"]}><ComoFunciona/></Guard>}/>
        <Route path="/contato"       element={<Contato/>}/>
        <Route path="/quem-somos"    element={<QuemSomos/>}/>
        <Route path="/redefinir-senha"      element={<RedefinirSenha/>}/>

        <Route path="*" element={<Navigate to="/" replace/>}/>
      </Routes>
    </BrowserRouter>
  );
}
